import { IApolloSearchPartnersResult } from 'legacy/lut/classes/models/apollo'
import { calculatePartnerDifference } from 'legacy/lut/helpers/partners/calculatePartnerDifference'

import { IPartner, IPartnerDuplicate } from 'clickNgo/entities/partner/models'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IFilter, Operator } from 'core-components/types'

import { fetchPartnerRequestList } from '../../fetchPartnerRequestList'
import { DUPLICATES_CHECK_FIELDS } from '../configs'
import { mapPartnerFromApolloSearchResult } from '../mapping/mapPartnerFromApolloSearchResult'

import { checkCriticalMatch } from './checkCriticalMatch'
import { checkSamePartner } from './checkSamePartner'
import { filterExternalPartners } from './filterExternalPartners'
import { filterParentPartners } from './filterParentPartners'

interface IGetPreparedPartnerDuplicatesData {
  apolloSearchResult: IApolloSearchPartnersResult[]
  partner: IPartner
  duplicatesCheckFields?: (keyof IPartner)[]
}

export const getPreparedPartnerDuplicatesData = async (
  {
    apolloSearchResult,
    partner,
    duplicatesCheckFields = DUPLICATES_CHECK_FIELDS,
  }: IGetPreparedPartnerDuplicatesData,
  options?: ICrudFetchOptions
) => {
  if (apolloSearchResult.length === 0) {
    return []
  }
  const apolloPartnerList = apolloSearchResult.map(mapPartnerFromApolloSearchResult)

  const filters: IFilter[] = apolloPartnerList.map(({ partnerId }) => ({
    field: 'PartnerID',
    operator: Operator.EQUAL,
    value: partnerId,
  }))

  const partnerRequestList = await fetchPartnerRequestList(filters, options)
  const externalPartnerList = filterExternalPartners(apolloPartnerList, partnerRequestList)
  const preparedPartnerList = [...partnerRequestList, ...externalPartnerList].filter(
    (externalPartner) => filterParentPartners({ externalPartner, originalPartner: partner })
  )

  const duplicates: IPartnerDuplicate[] = preparedPartnerList.map((compared) => {
    return {
      partner: compared,
      isSame: checkSamePartner(partner, compared),
      isExternal: Boolean(!compared.entryId),
      isInactive: Boolean(compared.status.match(/inactive/i)),
      hasCriticalMatch: checkCriticalMatch(apolloSearchResult, compared),
      difference: calculatePartnerDifference({
        compared,
        original: partner,
        fields: duplicatesCheckFields,
      }),
    }
  })

  return duplicates
}
